/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setAppState } from '../../Store/features/appStateSlice';

type Props = {
  state?: string;
  children: ReactNode;
};

const PageWrapper = (props: Props): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.state) {
      dispatch(setAppState(props.state));
    }
  }, [dispatch, props]);

  return <>{props.children}</>;
};

export default PageWrapper;
